export enum TaskStatus {
    STARTED = "STARTED",
    RUNNING_QUEUE = "RUNNING_QUEUE",
    RUNNING_TASK = "RUNNING_TASK",
    RUNNING_VALIDATION = "RUNNING_VALIDATION",
    RUNNING_TRANSFORM = "RUNNING_TRANSFORM",
    FAILED = "FAILED",
    SUCCESS = "SUCCESS"
  }